import React from "react";
import { IoCheckmarkDoneOutline, IoCopyOutline } from "react-icons/io5";

const InstanceIndex = ({ label, value, copyIcon, color = 'black' }) => {
  const [copy, setCopy] = React.useState(false);
  const onCopy = () => {
    navigator.clipboard.writeText(value)
    setCopy(true)
    setTimeout(() => {
      setCopy(false)
    }, 1000);
  }

  return (
    <div className="flex flex-row justify-between w-full p-6">
      <h1>{label}</h1>
      <div className="flex">
        <h1 style={{color}} className="opacity-50">{value}</h1>
        {copyIcon ? (copy ? <IoCheckmarkDoneOutline size={20} className="mx-2" color="green" /> : <IoCopyOutline className="mx-2" size={20} onClick={onCopy} color="green" cursor={'pointer'} />) : null}
      </div>
    </div>
  );
};

export default InstanceIndex;
